module.exports = __webpack_public_path__ + "img/img044.6cf25bab.png";